export default {"src":"/_next/static/media/ron.d7cf8d44.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};